export default __webpack_public_path__ + "8571e4c3f2c417f4e2059ed84764b45d.png";